import BulkActionConsult from './BulkActionConsult';

export default BulkActionConsult;
